import { render, staticRenderFns } from "./RelatorioVigenciaContratoForm.vue?vue&type=template&id=1b47795c&scoped=true&"
import script from "./RelatorioVigenciaContratoForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioVigenciaContratoForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioVigenciaContratoForm.vue?vue&type=style&index=0&id=1b47795c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47795c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
